import gql from 'graphql-tag'
import { ApolloClient } from 'apollo-client'

export const mutationUpdateAttackEventNotesViewed = gql`
  mutation UpdateAttackEventNotesViewed(
    $organizationId: ID!
    $attackEventUuid: ID!
  ) {
    updateAttackEventNotesViewed(
      input: {
        organizationId: $organizationId
        attackEventUuid: $attackEventUuid
      }
    ) {
      _placeholder
    }
  }
`

export function dispatchUpdateAttackEventNotesViewed(
  apolloClient: ApolloClient<any>,
  organizationId: string,
  attackEventUuid: string
) {
  //  TODO: Can this be simplified to not need a reference to a client but to automatically pull it?
  //  TODO: Do we need error handling? probably not for this case
  // eslint-disable-next-line @typescript-eslint/no-floating-promises
  apolloClient.mutate({
    mutation: mutationUpdateAttackEventNotesViewed,
    variables: {
      organizationId,
      attackEventUuid
    }
  })
}
